<template>
  <b-modal
    :visible="visible"
    :title="$t('page.groups.createGroup')"
    @hide="$emit('close')"
    @ok.prevent="submit"
    :ok-title="$t('button.createGroup')"
    :cancel-title="$t('button.cancel')"
  >
    <b-form @submit.prevent="submit">
      <b-form-group :label="$t('page.groups.groupName')" label-for="group-name">
        <b-form-input
          id="group-name"
          v-model="form.name"
          :placeholder="$t('page.groups.groupNamePlaceholder')"
        />
      </b-form-group>

      <b-form-group :label="$t('page.groups.adminClient')" label-for="group-admin">
        <b-form-select
          id="group-admin"
          v-model="form.adminId"
          :options="clientOptions"
          required
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              {{ $t("page.groups.selectAdmin") }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group :label="$t('page.groups.licenses')" label-for="group-licenses">
        <b-form-input
          id="group-licenses"
          v-model.number="form.licenses"
          type="number"
          min="1"
          required
        />
      </b-form-group>

      <b-form-group :label="$t('page.groups.allowedDomains')">
        <div
          v-for="(entry, index) in form.allowedDomains"
          :key="index"
          class="d-flex mb-1"
        >
          <b-form-input
            v-model="entry.domain"
            :placeholder="$t('page.groups.domainPlaceholder')"
            class="mr-2"
          />
          <b-button variant="outline-danger" size="sm" @click="removeDomain(index)">
            &times;
          </b-button>
        </div>
        <b-button variant="outline-secondary" size="sm" @click="addDomain">
          + {{ $t("page.groups.addDomain") }}
        </b-button>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: "",
        adminId: null,
        licenses: 1,
        allowedDomains: [],
      },
    };
  },
  computed: {
    clientList() {
      return this.$store.getters["clients/getClientList"];
    },
    clientOptions() {
      return this.clientList.map(c => ({
        value: c._id,
        text: `${c.firstName || ""} ${c.lastName || ""} (${c?.registration?.email})`.trim(),
      }));
    },
  },
  watch: {
    visible(val) {
      if (val) this.resetForm();
    },
  },
  methods: {
    resetForm() {
      this.form = { name: "", adminId: null, licenses: 1, allowedDomains: [] };
    },
    addDomain() {
      this.form.allowedDomains.push({ domain: "", status: "active" });
    },
    removeDomain(index) {
      this.form.allowedDomains.splice(index, 1);
    },
    submit() {
      if (!this.form.adminId || this.form.licenses < 1) return;

      const payload = {
        adminId: this.form.adminId,
        licenses: this.form.licenses,
      };
      if (this.form.name) payload.name = this.form.name;
      if (this.form.allowedDomains.length > 0) {
        payload.allowedDomains = this.form.allowedDomains.filter(d => d.domain);
      }

      this.$store.commit("loader/SET_LOADER", {});
      this.$store
        .dispatch("groups/createGroup", payload)
        .then(group => {
          this.$emit("created", group);
        })
        .catch(() => {})
        .finally(() => this.$store.dispatch("loader/close"));
    },
  },
};
</script>

<style scoped></style>
